(function () {
  if (window.__mbFreeShippingBar) return;
  window.__mbFreeShippingBar = true;

  var ROOT_SELECTOR = '[data-mb-fsb]';
  var CONFIG_SELECTOR = '[data-mb-fsb-config]';
  var CART_MUTATION = /\/cart\/(?:add|change|update|clear)(?:\.js)?(?:\?|$)/i;
  var THEME_EVENTS = [
    'cart:updated',
    'cart:update',
    'cart:change',
    'cart:changed',
    'cart:refresh',
    'cart:added',
    'ajaxProduct:added',
    'theme:cart:change'
  ];
  var AMOUNT_TOKEN = /\{\{\s*amount\s*\}\}/;
  var pending = false;
  var queued = false;

  function roots() {
    return document.querySelectorAll(ROOT_SELECTOR);
  }

  function hasActiveThreshold() {
    var nodes = roots();
    for (var i = 0; i < nodes.length; i++) {
      var config = readConfig(nodes[i]);
      if (config && config.thresholdCents > 0) return true;
    }
    return false;
  }

  function readConfig(root) {
    if (root.__mbFsbConfig) return root.__mbFsbConfig;

    var script = root.querySelector(CONFIG_SELECTOR);
    if (!script) return null;

    try {
      var parsed = JSON.parse(script.textContent);
      root.__mbFsbConfig = {
        thresholdCents: Number(parsed.thresholdCents) || 0,
        showProgress: Boolean(parsed.showProgress),
        progressMessage: parsed.progressMessage || '',
        metMessage: parsed.metMessage || '',
        defaultMessage: parsed.defaultMessage || '',
        note: parsed.note || '',
        moneyFormat: parsed.moneyFormat || '${{amount}}'
      };
      return root.__mbFsbConfig;
    } catch (err) {
      return null;
    }
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents);
    if (!isFinite(cents)) cents = 0;

    var formatString = String(format || '${{amount}}').replace(/<[^>]*>/g, '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholder);
    if (!match) return String(cents / 100);

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;

      var value = (Math.abs(number) / 100).toFixed(precision);
      var parts = value.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var remainder = parts[1] ? decimal + parts[1] : '';
      return (number < 0 ? '-' : '') + dollars + remainder;
    }

    var formatted;
    switch (match[1]) {
      case 'amount_no_decimals':
        formatted = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        formatted = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        formatted = withDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        formatted = withDelimiters(cents, 0, ' ', '');
        break;
      case 'amount_with_space_separator':
        formatted = withDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_with_period_and_space_separator':
        formatted = withDelimiters(cents, 2, ' ', ',');
        break;
      default:
        formatted = withDelimiters(cents, 2);
    }

    return formatString.replace(placeholder, formatted);
  }

  function appendNote(messageEl, note) {
    if (!note) return;
    var noteEl = document.createElement('span');
    noteEl.className = 'mb-fsb__note';
    noteEl.textContent = note;
    messageEl.appendChild(noteEl);
  }

  function renderProgress(messageEl, config, remainingCents) {
    var formatted = formatMoney(remainingCents, config.moneyFormat);
    var amountEl = messageEl.querySelector('.mb-fsb__amount');

    if (messageEl.getAttribute('data-mode') === 'progress' && amountEl) {
      if (amountEl.textContent !== formatted) amountEl.textContent = formatted;
      return;
    }

    messageEl.textContent = '';
    messageEl.setAttribute('data-mode', 'progress');

    var parts = String(config.progressMessage).split(AMOUNT_TOKEN);
    messageEl.appendChild(document.createTextNode(parts[0] || ''));

    var span = document.createElement('span');
    span.className = 'mb-fsb__amount';
    span.setAttribute('data-threshold-cents', String(config.thresholdCents));
    span.textContent = formatted;
    messageEl.appendChild(span);

    if (parts.length > 1) {
      messageEl.appendChild(document.createTextNode(parts.slice(1).join(formatted)));
    }

    appendNote(messageEl, config.note);
  }

  function renderText(messageEl, mode, text, note) {
    if (messageEl.getAttribute('data-mode') === mode) return;
    messageEl.textContent = '';
    messageEl.setAttribute('data-mode', mode);
    messageEl.appendChild(document.createTextNode(text || ''));
    appendNote(messageEl, note);
  }

  function updateBar(root, totalCents) {
    var config = readConfig(root);
    if (!config) return;

    var messageEl = root.querySelector('.mb-fsb__message');
    if (!messageEl) return;

    var remaining = config.thresholdCents - totalCents;

    if (config.showProgress && config.thresholdCents > 0 && remaining > 0) {
      renderProgress(messageEl, config, remaining);
    } else if (config.thresholdCents > 0 && remaining <= 0) {
      renderText(messageEl, 'met', config.metMessage, config.note);
    } else {
      renderText(messageEl, 'default', config.defaultMessage, config.note);
    }
  }

  function applyCart(cart) {
    var total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
    var nodes = roots();
    for (var i = 0; i < nodes.length; i++) {
      updateBar(nodes[i], total);
    }
  }

  function applyMutationPayload(payload) {
    if (payload && typeof payload.total_price === 'number') {
      applyCart(payload);
      return true;
    }
    return false;
  }

  function refresh() {
    if (!hasActiveThreshold()) return;
    if (pending) {
      queued = true;
      return;
    }

    pending = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart');
        return response.json();
      })
      .then(applyCart)
      .catch(function () {
        /* Keep the server-rendered message. */
      })
      .then(function () {
        pending = false;
        if (queued) {
          queued = false;
          refresh();
        }
      });
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function requestMethod(input, init) {
    if (init && init.method) return init.method;
    if (input && input.method) return input.method;
    return 'GET';
  }

  function isCartMutation(url, method) {
    return CART_MUTATION.test(String(url)) && /^(POST|PUT|PATCH|DELETE)$/i.test(method || 'GET');
  }

  function hookFetch() {
    if (typeof window.fetch !== 'function') return;
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var result = nativeFetch.apply(this, arguments);
      if (isCartMutation(requestUrl(input), requestMethod(input, init))) {
        result
          .then(function (response) {
            if (!response || !response.ok || typeof response.clone !== 'function') return;
            response
              .clone()
              .json()
              .then(function (payload) {
                if (!applyMutationPayload(payload)) refresh();
              })
              .catch(refresh);
          })
          .catch(function () {});
      }
      return result;
    };
  }

  function hookXhr() {
    if (!window.XMLHttpRequest) return;
    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__mbFsb = { method: method, url: url };
      return nativeOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      if (this.__mbFsb && isCartMutation(this.__mbFsb.url, this.__mbFsb.method)) {
        this.addEventListener('load', function () {
          if (this.status < 200 || this.status >= 300) return;

          var payload = this.response;
          if (!payload || typeof payload !== 'object') {
            try {
              payload = JSON.parse(this.responseText);
            } catch (err) {
              payload = null;
            }
          }

          if (!applyMutationPayload(payload)) refresh();
        });
      }
      return nativeSend.apply(this, arguments);
    };
  }

  function hookThemeEvents() {
    function onCartEvent(event) {
      var detail = event && event.detail;
      var cart = detail && detail.cart ? detail.cart : detail;
      if (!applyMutationPayload(cart)) refresh();
    }

    for (var i = 0; i < THEME_EVENTS.length; i++) {
      document.addEventListener(THEME_EVENTS[i], onCartEvent);
    }
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.querySelector(ROOT_SELECTOR)) refresh();
    });
  }

  hookFetch();
  hookXhr();
  hookThemeEvents();
})();

